import { showMessage } from 'app/messages/actions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { CopyButtonOwnProps } from './copy-button';

export const useCopyButton = (props: CopyButtonOwnProps) => {
  const { text, onCopy, 'data-testid': testId } = props;
  const dispatch = useDispatch();

  const handleCopy = useCallback(() => {
    dispatch(showMessage('info', 'Copied to clipboard!', 3000));
    onCopy?.();
  }, [dispatch, onCopy]);

  return { text, handleCopy, testId };
};

export type CopyButtonProps = ReturnType<typeof useCopyButton>;
